import { useState, useEffect, useRef } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const POLL_MS = 60 * 1000;

export function useYouTubeStats() {
  const [state, setState] = useState({ configured: false, loading: true });
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  useEffect(() => {
    async function poll() {
      try {
        const res  = await fetch(`${API}/api/youtube/hstv`, { credentials: "include" });
        const data = await res.json();
        if (!mountedRef.current) return;
        if (!res.ok || !data.configured) {
          setState({ configured: false, loading: false, error: data.error });
          return;
        }
        setState({ configured: true, loading: false, ...data });
      } catch (err) {
        if (!mountedRef.current) return;
        setState(prev => ({ ...prev, configured: false, loading: false, error: err.message }));
      }
    }

    poll();
    const timer = setInterval(poll, POLL_MS);
    return () => clearInterval(timer);
  }, []);

  return state;
}
